const SECRET = {
  NAMCOR_REG: process.env.REACT_APP_NAMCOR_REG || "",
};

export default SECRET;
